import { render } from "./BalanceListPage.vue?vue&type=template&id=cdea4976"
import script from "./BalanceListPage.vue?vue&type=script&lang=js"
export * from "./BalanceListPage.vue?vue&type=script&lang=js"

import "./BalanceListPage.vue?vue&type=style&index=0&id=cdea4976&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__